import { render, staticRenderFns } from "./CExpandableList.vue?vue&type=template&id=5f81d1ee&scoped=true&"
import script from "./CExpandableList.vue?vue&type=script&lang=js&"
export * from "./CExpandableList.vue?vue&type=script&lang=js&"
import style0 from "./CExpandableList.vue?vue&type=style&index=0&id=5f81d1ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f81d1ee",
  null
  
)

export default component.exports